// Survey New shows SurveyForm and SurveyFormReview
import React, {Component} from 'react';
import { reduxForm } from 'redux-form';
import SurveyForm from './SurveyForm';
import SurveyFormReview from './SurveyFormReview';

class SurveyNew extends Component {
    // constructor(props) { refactor this for > state = {formReview: false};
    //     super(props);

    //     this.state = (new: true);
    // }

    state = {showFormReview: false}; // state initalization

    renderContent() {
        if (this.state.showFormReview) {
            return <SurveyFormReview onCancel={() => this.setState({showFormReview: false})}/>;
        }

        return <SurveyForm onSurveySubmit={() => this.setState({showFormReview: true})}/>;
    }


    render(){
        return (
            <div>
                {this.renderContent()}
            </div>
        )
    }
}

export default reduxForm({ // clear form on cancel on new
    form: 'surveyForm',
})(SurveyNew);
